import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Login } from '../_model/login';
import { AuthService } from '../_services/auth.service';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    standalone: false
})
export class LoginComponent implements OnInit {

  faUserCircle = faUserCircle;

  constructor(private auth: AuthService, private router: Router) { }

  model: Login = new Login();

  ngOnInit() {
  }

  login() {
    this.auth.login(this.model).subscribe((data: any) => {
      localStorage.setItem("userId", data.result);
      console.log(data.first);
      if(data.first) {
        location.href = "/pass?first=true"
      }else {
        location.reload();
      }
    }, err => {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>"+err.error+"</h1>",
        icon: 'error',
        background: '#666666',
        iconColor: "#fff",
        customClass: {
          popup: 'card-border-gold',
          confirmButton: 'btn btn-grad px-8'
        }
      });
    });
  }

}
